import { render, staticRenderFns } from "./huiyxy_config.vue?vue&type=template&id=57009b31&scoped=true"
import script from "./huiyxy_config.vue?vue&type=script&lang=js"
export * from "./huiyxy_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57009b31",
  null
  
)

export default component.exports